export const EXAMINE_PROJECT_DEFAULT_SOLR_PARAMS = {
  T: "",
  excludeWord: "",
  filterMode: "2,1",
  keyword: "",
  keywordsAndOr: "|", // 且或关系、& = 且 、 | = 或
  newAreas: "",
  sortType: "2",
  summaryType: "0",
  timeType: "8",
  searchMode: "1",
  progIdAndNoticeSegmentTypeMaps: "{}",
  beginTime: "",
  endTime: "",
};
export const EXAMINE_PROJECT_TYPE = [
  {
    id: 36,
    text: "立项",
  },
  {
    id: 32,
    text: "可研",
  },
  {
    id: 33,
    text: "审批",
  },
  {
    id: 34,
    text: "备案",
  },
  {
    id: 35,
    text: "核准",
  },
  {
    id: 31,
    text: "环评",
  },
  {
    id: 61,
    text: "施工许可",
  },
  {
    id: 37,
    text: "竣工",
  },
];
export const EXAMINE_PROJECT_SEARCH_SCOPE = [
  {
    text: "标题",
    id: 2,
  },
  {
    text: "正文",
    id: 1,
    tip: "公告正文内容，不包含标题和附件",
  },
  {
    text: "附件",
    id: 10,
    tip: "公告中的附件文件，非文本类附件可能识别不完整",
  },
];
export const EXAMINE_PROJECT_MODE_LIST = [
  {
    id: 1,
    text: "精准",
  },
  {
    id: 0,
    text: "模糊",
  },
];
